import React, { ChangeEvent, FunctionComponent } from 'react';

import { FormControlElementProps } from '../Form.constants';
import TextArea from '../../TextArea';

type TextAreaFieldProps = {
  control: FormControlElementProps;
  inputChangedHandler: (name: string, value: string) => void;
};

const TextAreaField: FunctionComponent<TextAreaFieldProps> = ({ control, inputChangedHandler }) => {
  const { id, error, fieldType, label, required, touched, valid, validations, value, ...elementProps } = control;

  const handleOnChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    const { name, value } = event.target;
    inputChangedHandler(name, value);
  };

  return (
    <div key={`${fieldType}-${id}`}>
      <TextArea
        {...elementProps}
        id={id}
        value={value as string}
        required={required || !!validations?.required}
        title={label}
        error={touched && !valid ? error : ''}
        onChange={handleOnChange}
      />
    </div>
  );
};

export default TextAreaField;
